module.exports = __webpack_public_path__ + "img/fafc97b.png";